// extracted by mini-css-extract-plugin
module.exports = {"theme_switcher":"HeaderContentThemeSwitch_theme_switcher__Pi7_f","dark":"HeaderContentThemeSwitch_dark__2MGSF","light":"HeaderContentThemeSwitch_light__1WiYW"};